import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, Typography} from 'views/components';

import {Translate} from '../Translate';

import skillTypeViews from './type_views';

const SkillResponseView = (props) => {
  const {response} = props;

  if (!response) {
    return null;
  }

  const SkillDetail = skillTypeViews[response.outputType];

  return (
    <Stack
      sx={{
        px: '12px',
        gap: '8px',
      }}
    >
      <Typography
        sx={{
          px: '6px',
          fontSize: '12px',
          fontWeight: 600,
          lineHeight: '100%',
          color: '#A8A49E',
          textTransform: 'uppercase',
        }}
      >
        <Translate expression='skills.SkillsModule.Response.QueuedForApproval' />
      </Typography>
      <Box>
        {
          SkillDetail && (
            <SkillDetail {...props} />)
        }
      </Box>
    </Stack>
  );
};

SkillResponseView.propTypes = {
  communicationTarget: PropTypes.shape({
    email: PropTypes.string,
    sendEmail: PropTypes.func,
    sendSms: PropTypes.func,
    sms: PropTypes.string,
  }),
  isRegenerating: PropTypes.bool,
  onDiscard: PropTypes.func,
  onRegenerate: PropTypes.func,
  requester: PropTypes.object.isRequired,
  response: PropTypes.shape({
    content: PropTypes.string,
    message: PropTypes.string,
    outputType: PropTypes.string.isRequired,
    subject: PropTypes.string,
    text: PropTypes.string,
  }),
};

export default React.memo(SkillResponseView);
